import { render } from "./AccountAccess.vue?vue&type=template&id=474a5c78&scoped=true&ts=true"
import script from "./AccountAccess.vue?vue&type=script&lang=ts"
export * from "./AccountAccess.vue?vue&type=script&lang=ts"

import "./AccountAccess.vue?vue&type=style&index=0&id=474a5c78&scoped=true&lang=scss"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474a5c78"]])

export default __exports__